import React from 'react'

const Backdrop = ({ onClick, navMenuOpen }) => {
  return (
    <div className={`
      absolute
      top-20
      left-0
      w-screen
      h-[calc(100vh-5rem)]
      ${navMenuOpen ? '' : 'hidden'}
    `}>
      <div
        className={`
          w-full
          h-full
          from-[#000]
          bg-gradient-to-b
          to-[#0004]
          ${navMenuOpen ? 'opacity-100' : 'opacity-0'}
          transition-opacity
          duration-1000
        `}
        onClick={onClick}
      />
    </div>
  )
}

export default Backdrop
